import { render, staticRenderFns } from "./PopUpSelector.vue?vue&type=template&id=4055e326"
import script from "./PopUpSelector.vue?vue&type=script&lang=js"
export * from "./PopUpSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports